export default __webpack_public_path__ + "static/media/logo06.45f6d4f1.svg";